import { ConfigProvider, Modal, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserDealerDetails } from "../../redux/actions/userActions/dealerActions";
import Alertify from "../../services/alertify";
import { logout } from "../../redux/reducers/authSlice";

const { Title } = Typography;
const ShippingAddressesModal = (props) => {
  const authData = useSelector((state) => state.auth_store);
  const { isShippingAddressesModal, setIsShippingAddressesModal } = props;
  const [shippingAddresses, setShippingAddresses] = useState();
  const dispatch = useDispatch();
  const addressesCol = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Address", dataIndex: "street", key: "street" },
    { title: "City", dataIndex: "city", key: "city" },
    { title: "State", dataIndex: "state", key: "state" },
    { title: "Pincode", dataIndex: "pincode", key: "pincode" },
  ];
  useEffect(() => {
    const dealer_code = authData?.defaultDealerCode;
    if (!dealer_code) return;
    dispatch(UserDealerDetails({ dealerCode: dealer_code }))
      .then((response) => {
        // console.log("Dealer Details are:", response);
        if (
          response?.error?.message &&
          (response?.error?.message.toLowerCase().includes("expired") ||
            response?.error?.message.toLowerCase().includes("invalid"))
        ) {
          Alertify.error("Your session is expired. Please login again.");
          dispatch(logout());
          //   setLocation("/login/dealer");
          return;
        }
        const res = response?.payload?.data;
        setShippingAddresses(res?.shipping_addresses);
      })
      .catch((error) => {
        Alertify.error("Error fetching dealer details:", error);
        dispatch(logout());
        props.setLocation("/login/dealer");
        return;
      });
  }, [dispatch, authData, setShippingAddresses]);
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <Modal
        open={isShippingAddressesModal}
        onCancel={() => setIsShippingAddressesModal(false)}
        footer={false}
        width={1000}
        centered
      >
        <div>
          <div className="flex items-center gap-16">
            <Title level={3}>Address List</Title>
          </div>
          <Table
            className="max-w-full mx-8"
            size="small"
            pagination={false}
            columns={addressesCol}
            dataSource={shippingAddresses}
          />
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ShippingAddressesModal;
